// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"dc6f14d0","455":"5ac72e3f","977":"d3ede4af"}[chunkId] + ".chunk.js";
};